import { User } from "@/models/user.model";
import router from "@/router";
import { BehaviorSubject } from "rxjs";
import { getItemStorage, setItemStorage } from "./save-storage.util";

const storageUser: string = "user";
const emptyImg: string =
  "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png";

var user$ = new BehaviorSubject<User>(new User());

function getTokenFromStorage(): string {
  var token: string = "";
  const session = getItemStorage(storageUser);
  const objUser = session && JSON.parse(session);
  if (objUser?.token) token = `Bearer ${objUser.token}`;
  else token = "no token";
  return token;
}

function getUserFromStorage(hasUser?: any): User {
  const user = JSON.parse(getItemStorage(storageUser) as string);
  if (user) {
    var arrName = user.userName?.split(" ");
    user.firstName = arrName ? arrName[0] : "";
  }
  return hasUser ?? user;
}

function storeUser(user: User): void {
  const userStr = JSON.stringify(user);
  setItemStorage("user", userStr);
  user$.next(user);
}

function clearStorage(): void {
  localStorage.clear();
  sessionStorage.clear();
  router.push({ name: "sign-in" });
  user$.next(new User());
}

export {
  clearStorage,
  emptyImg,
  getTokenFromStorage,
  getUserFromStorage,
  storeUser,
  user$,
};
